import { JiraTestSuite } from '../../interfaces/ui/testPlan';

export function mapTestSuiteResponse(response: any) {
  if (!response) {
    return [];
  }

  const suiteData = response?.data?.testsuites?.value;

  if (!suiteData) return [];

  return suiteData.map((testSuite: any) => {
    return {
      id: testSuite.id,
      name: testSuite.name,
      suiteType: testSuite.suiteType,
      parentSuiteId: testSuite.parentSuiteId,
      lastUpdatedDate: new Date(testSuite.lastUpdatedDate),
      revision: testSuite.revision,
      testCasesUrl: testSuite.testCasesUrl,
    };
  });
}

export function mapJiraTestSuites(testSuiteData: any[]): JiraTestSuite[] {
  return testSuiteData.map(testSuite => {
    return {
      id: testSuite.id,
      name: testSuite.name,
      sequence: testSuite.sequence,
      parentId: testSuite.parentId,
      created: {
        by: testSuite.created.by,
        on: new Date(testSuite.created.on),
      },
      updated: {
        by: testSuite.updated.by,
        on: new Date(testSuite.updated.on),
      },
    };
  });
}
